import { createSelector } from 'reselect';
import { getDeviationById } from '../deviations/selectors';
import { getCompositeId } from '../normalizr/schemas/deviation';
import { DeviationResourceType } from '../../types/deviation';
import { CommissionStatusCodes } from '../../types/commissions';
import { reduxKey } from './constants';
function getSlice(state) {
    return state[reduxKey] || {
        submittingState: 'idle',
        submitErrorString: ''
    };
}
export const getSubmittingState = createSelector(getSlice, (slice)=>slice.submittingState);
export const getSubmitErrorString = createSelector(getSlice, (slice)=>slice.submitErrorString);
export const getCommissionById = (state, id)=>getDeviationById(state, getCompositeId(DeviationResourceType.COMMISSION, id));
export const getIsDeleted = createSelector([
    getCommissionById
], (deviation)=>{
    try {
        return deviation.commission.status === CommissionStatusCodes.STATUS_DELETED;
    } catch (e) {
        return false;
    }
});
export const getIsActive = createSelector([
    getCommissionById,
    getIsDeleted
], (deviation, isDeleted)=>{
    try {
        return !isDeleted && deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE;
    } catch (e) {
        return false;
    }
});

//# sourceMappingURL=selectors.js.map